export const forumData = [
  {
    heading: "Forum Guidelines",
    description:
      "Welcome to the Film Help Squad Forum! Our forum is a vibrant community where filmmakers, actors, writers, and industry professionals gather to discuss, learn, collaborate, and share their passion for the world of cinema. To ensure that everyone enjoys a positive and respectful experience, please adhere to the following guidelines:",
    subData: [
      {
        head: "1. Be Respectful",
        desc: `Treat all forum members with respect and courtesy. We have a diverse community, and it's essential to maintain a friendly and inclusive atmosphere. Avoid personal attacks, harassment, or any form of discrimination.`,
      },
      {
        head: "2. Stay On Topic",
        desc: `Please keep your posts relevant to the forum category you're posting in. If you have a new topic to discuss, consider starting a new thread in the appropriate category. Off-topic posts may be moved or removed.`,
      },
      {
        head: "3. No Spam or Self-Promotion",
        desc: `Spamming, excessive self-promotion, and advertising unrelated to filmmaking are not allowed. If you wish to promote your own work or services, please do so in the designated areas, such as the 'Collaboration Corner.'`,
      },
      {
        head: "4. Respect Intellectual Property",
        desc: `Respect the intellectual property rights of others. Do not post copyrighted materials without proper authorization or attribution. If you are sharing someone else's work, be sure to credit the source.`,
      },
      {
        head: "5. Avoid Plagiarism",
        desc: `Do not copy and paste content from other sources without proper attribution or permission. If you're sharing information or insights from external sources, provide a link and give credit to the original author.`,
      },
      {
        head: "6. Keep It Civil",
        desc: `Engage in constructive and civil discussions. Disagreements are okay, but please express your opinions respectfully and avoid inflammatory language or trolling.`,
      },
      {
        head: "7. Use Proper Language and Etiquette",
        desc: `Use appropriate language and avoid profanity or offensive content. Remember that our community is open to all age groups.`,
      },
      {
        head: "8. Privacy and Confidentiality",
        desc: `Respect the privacy and confidentiality of other forum members. Do not share personal or sensitive information without permission.`,
      },
      {
        head: "9. Reporting Issues",
        desc: `If you encounter any violations of these guidelines or witness inappropriate behavior, please report it to the forum moderators or administrators. We rely on our community members to help maintain a positive environment.`,
      },
      {
        head: "10. Follow Forum Rules and Policies",
        desc: `These guidelines should be read in conjunction with our overall Terms and Conditions and Privacy Policy. By participating in our forum, you agree to abide by these rules and policies.`,
      },
    ],
    bottomHead: "Consequences of Violations",
    bottomDesc1:
      "Failure to adhere to these guidelines may result in warnings, temporary suspensions, or permanent bans from the forum, depending on the severity of the violation. Our goal is to maintain a respectful and productive community for all members.",
    bottomDesc2:
      "Thank you for being part of the Film Help Squad Forum community. We look forward to engaging with you, sharing knowledge, and celebrating the art of filmmaking together!",
  },
];
